import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchImpcStockLevelsListWithCentralEntryPoint = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcStockLevelsListWithCentralEntryPoint',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiFetchImpcStockLevelsListWithCentralEntryPoint;
